/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminGetCustomerInvolvedContributionHistory} from '../api'

export const useMutationAdminGetCustomerInvolvedContributionHistory = createReactQueryMutationHook('adminGetCustomerInvolvedContributionHistory', adminGetCustomerInvolvedContributionHistory)
